module.exports = __webpack_public_path__ + "static/media/yourplaces-full.0cc08f39.png";